import React, { useState } from 'react';

import { Control, Page } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import styles from './vmsSettingModal.module.scss';

export function VmsSettingModal({ close }) {
  const { t } = useTranslation();

  const cookiePlayDelay = localStorage.getItem('playerDelay');
  const [playerDelay, setPlayerDelay] = useState(cookiePlayDelay || '5');

  const handleChange = (event) => {
    setPlayerDelay(event.target.value);
  };

  const handleSave = () => {
    localStorage.setItem('playerDelay', playerDelay);
    close();
  };

  return (
    <Page>
      <div className={styles.vmsSettingModal}>
        <h6>{t('vms:table.settings')}</h6>
        <div>
          <span>{t('vms:table.player_delay_before_event')}</span>
          <Control.Input onChange={handleChange} value={playerDelay} />
        </div>
        <Control.Button onClick={handleSave}>
          {t('btn.save')}
        </Control.Button>
      </div>
    </Page>
  );
}
